import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  // Wolane po zlapaniu bledu: rodzic moze zdjac swoje „ladowanie” (np. nakladke na karcie).
  onBlad?: () => void;
}

interface State {
  blad: Error | null;
}

/**
 * Granica bledu wokol map Google: wyjatek z biblioteki map (konflikt opcji Loadera, blad
 * AdvancedMarkerElement, brak Map ID po stronie Google) gasi tylko mape, a strona dziala dalej.
 */
class GranicaBleduMapy extends Component<Props, State> {
  state: State = { blad: null };

  static getDerivedStateFromError(blad: Error): State {
    return { blad };
  }

  componentDidCatch(blad: Error, info: ErrorInfo) {
    console.error('[Mapa] Błąd mapy, reszta strony działa dalej:', blad, info.componentStack);
    try { this.props.onBlad?.(); } catch {}
  }

  render() {
    if (this.state.blad) {
      return (
        <div style={{ fontSize: '11px', color: 'var(--muted)', padding: '8px' }}>
          Mapa jest chwilowo niedostępna.
        </div>
      );
    }
    return this.props.children;
  }
}

export default GranicaBleduMapy;
